export default __webpack_public_path__ + "static/media/rnr-sports-table-26.2eb2f2c0.webp";